/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminOfferApiResponse } from '../models/AdminOfferApiResponse';
import type { AdminOfferListApiResponse } from '../models/AdminOfferListApiResponse';
import type { CreateOfferDto } from '../models/CreateOfferDto';
import type { DeleteOfferApiResponse } from '../models/DeleteOfferApiResponse';
import type { DuplicateOfferDto } from '../models/DuplicateOfferDto';
import type { OfferMarketsApiResponse } from '../models/OfferMarketsApiResponse';
import type { UpdateOfferDto } from '../models/UpdateOfferDto';
import type { UpdateOfferStatusDto } from '../models/UpdateOfferStatusDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminOffersService {
    /**
     * List offers
     * Newest first; status is derived on read.
     * @param status Filter by derived status
     * @param marketCode Only offers targeting this dial code. URL-encode the plus sign (%2B971).
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns AdminOfferListApiResponse Offers fetched
     * @throws ApiError
     */
    public static adminOffersControllerListOffersV1(
        status?: 'scheduled' | 'live' | 'paused' | 'ended',
        marketCode?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<AdminOfferListApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/offers',
            query: {
                'status': status,
                'marketCode': marketCode,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Create an offer
     * Whole days in UAE time; lastDay must be on or after startDate and today.
     * @param requestBody
     * @returns AdminOfferApiResponse Offer created
     * @throws ApiError
     */
    public static adminOffersControllerCreateOfferV1(
        requestBody: CreateOfferDto,
    ): CancelablePromise<AdminOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/offers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                409: `Overlaps another active offer for the same country or for guests`,
            },
        });
    }
    /**
     * List markets an offer can target, with currency and UTC offset
     * @returns OfferMarketsApiResponse Markets fetched
     * @throws ApiError
     */
    public static adminOffersControllerListOfferMarketsV1(): CancelablePromise<OfferMarketsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/offers/markets',
        });
    }
    /**
     * Get an offer
     * @param id Offer UUID
     * @returns AdminOfferApiResponse Offer fetched
     * @throws ApiError
     */
    public static adminOffersControllerGetOfferV1(
        id: string,
    ): CancelablePromise<AdminOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/offers/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Offer not found`,
            },
        });
    }
    /**
     * Update an offer
     * Ended offers are read-only. Pause or resume with PATCH /admin/offers/{id}/status.
     * @param id Offer UUID
     * @param requestBody
     * @returns AdminOfferApiResponse Offer updated
     * @throws ApiError
     */
    public static adminOffersControllerUpdateOfferV1(
        id: string,
        requestBody: UpdateOfferDto,
    ): CancelablePromise<AdminOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/offers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                404: `Offer not found`,
                409: `Overlap, the offer has ended, or startDate changed after the offer started`,
            },
        });
    }
    /**
     * Delete an offer that has not started; started offers are paused
     * @param id Offer UUID
     * @returns DeleteOfferApiResponse Offer deleted
     * @throws ApiError
     */
    public static adminOffersControllerDeleteOfferV1(
        id: string,
    ): CancelablePromise<DeleteOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/admin/offers/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Offer not found`,
                409: `The offer has already started`,
            },
        });
    }
    /**
     * Duplicate an offer with new dates; the copy is created paused
     * @param id Offer UUID
     * @param requestBody
     * @returns AdminOfferApiResponse Offer duplicated
     * @throws ApiError
     */
    public static adminOffersControllerDuplicateOfferV1(
        id: string,
        requestBody: DuplicateOfferDto,
    ): CancelablePromise<AdminOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/offers/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                404: `Offer not found`,
            },
        });
    }
    /**
     * Pause or resume an offer; resuming runs the overlap check
     * @param id Offer UUID
     * @param requestBody
     * @returns AdminOfferApiResponse Offer status updated
     * @throws ApiError
     */
    public static adminOffersControllerUpdateOfferStatusV1(
        id: string,
        requestBody: UpdateOfferStatusDto,
    ): CancelablePromise<AdminOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/offers/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                404: `Offer not found`,
                409: `Overlap on resume, or the offer has ended`,
            },
        });
    }
}
